import {
  clientPortalCompanyPropertiesDefinition,
  clientPortalIndividualPropertiesDefinition,
  getDefaultBlocks,
  getPropertyTranslation,
  getStepTranslation,
} from '../..';
import {
  ClientPortalAvailableDefaultLanguageEnum,
  ClientPortalBlockFieldModel,
  ClientPortalStepModel,
  ClientPortalStepTypeEnum,
  ClientPortalTypeEnum,
  PropertyMappingEntityEnum,
} from '../../../../shared/models';
import {
  clientPortalStepDefinitionsRecord,
  getClientPortalStepDefinition,
} from '../definitions';

export const getDefaultStepTypes = (
  clientPortalType: ClientPortalTypeEnum,
): Exclude<
  ClientPortalStepTypeEnum,
  typeof ClientPortalStepTypeEnum.custom
>[] => {
  return Object.values(ClientPortalStepTypeEnum)
    .filter(
      (
        t: ClientPortalStepTypeEnum,
      ): t is Exclude<
        ClientPortalStepTypeEnum,
        typeof ClientPortalStepTypeEnum.custom
      > => t !== ClientPortalStepTypeEnum.custom,
    )
    .filter(
      (
        t: Exclude<
          ClientPortalStepTypeEnum,
          typeof ClientPortalStepTypeEnum.custom
        >,
      ) => {
        const definition = clientPortalStepDefinitionsRecord[t];
        return definition.clientPortalType.includes(clientPortalType);
      },
    );
};

export const defaultStepTypesKYB = getDefaultStepTypes(
  ClientPortalTypeEnum.KYB,
);
export const defaultStepTypesKYC = getDefaultStepTypes(
  ClientPortalTypeEnum.KYC,
);

export const buildDefaultClientPortalSteps = (
  clientPortalType: ClientPortalTypeEnum,
  defaultLanguage: ClientPortalAvailableDefaultLanguageEnum,
): (Pick<
  ClientPortalStepModel,
  'type' | 'key' | 'title' | 'description' | 'position' | 'isVisible' | 'config'
> & {
  blocks: Pick<
    ClientPortalBlockFieldModel,
    | 'type'
    | 'key'
    | 'description'
    | 'position'
    | 'mapping'
    | 'label'
    | 'display'
    | 'isRequired'
  >[];
})[] => {
  const defaultStepTypes = getDefaultStepTypes(clientPortalType);

  return defaultStepTypes.map((stepType) => {
    const stepDefinition = getClientPortalStepDefinition(stepType);

    const { title, description } = getStepTranslation(
      stepType,
      defaultLanguage,
    );

    const defaultBlocks = getDefaultBlocks(stepDefinition.type);
    const clientPortalCompanyDefinitionMappingKeys = Object.values(
      clientPortalCompanyPropertiesDefinition,
    ).map((p) => p.mapping.key);
    const clientPortalIndividualDefinitionMappingKeys = Object.values(
      clientPortalIndividualPropertiesDefinition,
    ).map((p) => p.mapping.key);
    const clientPortalDefinitionMappingKeys = [
      ...clientPortalCompanyDefinitionMappingKeys,
      ...clientPortalIndividualDefinitionMappingKeys,
    ];

    return {
      type: stepDefinition.type,
      key: stepDefinition.type,
      title,
      description,
      position: stepDefinition.position,
      isVisible: stepDefinition.defaultVisibility,
      config: stepDefinition.defaultConfig,
      blocks: defaultBlocks.map((block) => {
        if (
          (block.mapping.entity === PropertyMappingEntityEnum.individual ||
            block.mapping.entity === PropertyMappingEntityEnum.company) &&
          clientPortalDefinitionMappingKeys.includes(block.mapping.key)
        ) {
          return {
            ...block,
            label: getPropertyTranslation(defaultLanguage, {
              entity: block.mapping.entity,
              key: block.mapping.key,
            }).label,
          };
        }

        return block;
      }),
    };
  });
};
